import { Layout } from "antd";
import { FunctionComponent, useContext } from "react";
import { Link } from "react-router-dom";
import AppImage from "../../shared/app-image";
import CopyRight from "../../shared/copy-right";
import logo from "../assets/logo-128.png";
import { AppContext } from "../contexts/app-context";
const { Header, Footer, Sider, Content } = Layout;
interface PublicLayoutProps {}

const PublicLayout: FunctionComponent<PublicLayoutProps> = ({ children }) => {
  const { appRoot } = useContext(AppContext);
  return (
    <Layout className="public-layout">
      <Header>
        <Link to={{ pathname: appRoot }}>
          <AppImage height={55} src={logo} />
        </Link>
      </Header>
      <Content>{children}</Content>
      <Footer>
        <CopyRight />
      </Footer>
    </Layout>
  );
};

export default PublicLayout;
